import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { MappingSystemColumn, SystemColumnOption } from '../ninja-meta/ninja-meta.component';
import { SettingsNinjaService, NinjaDefaults, NinjaDefaultsEventLayerConfig, NinjaSystemColumnsMapping, NinjaSystemColumnMappingMethod } from '../../../../common-services/settings-ninja.service';
import { AppinfoService } from '../../../../common-services/appinfo.service';
import { AppSettings } from '../../../../app.settings';
import { ToastrService } from 'ngx-toastr';
import { CommonFunctionService } from '../../../../common-services/common-function.service';

export interface ModalSystemColumnsInput {
	layerName: string
}
export interface ModalSystemColumnsOutput {
	updated?: boolean;
}

@Component({
	selector: 'app-ninja-system-column-mapping',
	templateUrl: './ninja-system-column-mapping.component.html',
	styleUrls: ['./ninja-system-column-mapping.component.css', '../ninja-meta/ninja-meta.component.css']
})
export class NinjaSystemColumnMappingComponent implements OnInit {

	public systemColumns: MappingSystemColumn[];
	public systemColumnOptions: SystemColumnOption[];

	public hasChanged: boolean;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ModalSystemColumnsInput,
		public dialogRef: MatDialogRef<NinjaSystemColumnMappingComponent>,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private commonService: CommonFunctionService,
		private ninjaService: SettingsNinjaService
	) { }

	public onMapSystemColumn(col) {
		this.hasChanged = true;
	}
	public cancel() {
		this.dialogRef.close();
	}
	public async apply() {
		this.commonService.setLoadingSpinner(true);
		// Update system columns
		let mapping: NinjaSystemColumnsMapping = {};
		const mappingCols = [];
		this.systemColumns.forEach(c => {
			if (c.mappedCol) {
				mapping[c.attrValue] = c.mappedCol;
				mappingCols.push(c.mappedCol);
			}
		});
		//
		const storedDefaults = this.ninjaService.ninjaDefaults;
		storedDefaults.eventLayers = storedDefaults.eventLayers || {};
		const template = storedDefaults.systemColumnsMappingLayerTemplate;
		let mappingMethod: NinjaSystemColumnMappingMethod;
		if (template && template.mapping) {

			const isSame = !Object.keys(template.mapping).find(key => {
				return mapping[key] !== template.mapping[key];
			});
			if (isSame) {
				mappingMethod = 'standard';
			} else {
				mappingMethod = 'customized';
			}
		} else {
			mappingMethod = 'customized';
		}

		const storedLayerConfig = storedDefaults.eventLayers[this.data.layerName];
		const updatedLayerConfig: NinjaDefaultsEventLayerConfig = {
			systemColumns: {
				mappingMethod: mappingMethod,
				mapping: mappingMethod === 'standard' ? null : mapping
			},
			columns: storedLayerConfig ? storedLayerConfig.columns : null,
		};
		storedDefaults.eventLayers[this.data.layerName] = updatedLayerConfig;
		try {
			await this.appinfoService.updateDefaultValue(storedDefaults, AppSettings.ninjaAppName);
			const info = await this.appinfoService.getCustomerAppInfoNinja();
			this.ninjaService.ninjaDefaults = info.defaults;
			this.toastr.success('Successfully updated.');
			const data: ModalSystemColumnsOutput = {
				updated: true
			};
			this.dialogRef.close(data);
			this.commonService.setLoadingSpinner(false);
		} catch (err) {
			console.log(err);
			this.toastr.error('Failed.');
			this.commonService.setLoadingSpinner(false);
		}
	}
	ngOnInit() {
		const defaults: NinjaDefaults = JSON.parse(JSON.stringify(this.ninjaService.ninjaDefaults));
		const layersConfig = defaults.eventLayers || {};
		const result = this.ninjaService.getSystemColumnsMappingAndOptions(this.data.layerName, layersConfig[this.data.layerName]);
		this.systemColumns = result.systemColumns;
		this.systemColumnOptions = result.systemColumnOptions;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/settings-ninja/ninja-system-column-mapping/ninja-system-column-mapping.component.ts